module.exports = __webpack_public_path__ + "static/media/Ahmed Khidhir Profile Picture.9cd1b3d1.jpg";